import api from './api';

export const subscriptionService = {
  getStatus: async () => {
    return await api.get('/subscriptions/status');
  },

  selectPackage: async (packageType) => {
    return await api.post('/subscriptions/select-package', { package: packageType });
  },

  renew: async (packageType) => {
    return await api.post('/subscriptions/renew', { package: packageType });
  },

  exportPDF: async () => {
    return await api.post('/subscriptions/export/pdf');
  }
};
